import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=c9bed500&"
import script from "./RegisterPassword.vue?vue&type=script&lang=js&"
export * from "./RegisterPassword.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports